import { pngChartMaker } from '../../../components/graphs/pngChartMaker.js';
import { IMAGE_FACTOR, PNG_HEIGHT, PNG_WIDTH } from '../../summaryV2/utils/constants.js';
import { MarketTrendsSummaryChart } from './MarketTrendsSummaryChart.js';
import { MarketTrendsExportDeps, MarketTrendsHelpers } from './types.js';

type Props = {
  marketTrendsHelpers: MarketTrendsHelpers;
};

export async function makeMarketTrendsExportDeps(props: Props): Promise<MarketTrendsExportDeps> {
  const { marketTrendsHelpers } = props;
  const chartURL = await pngChartMaker(MarketTrendsSummaryChart, {
    width: PNG_WIDTH * IMAGE_FACTOR,
    height: PNG_HEIGHT * IMAGE_FACTOR,
    marketTrendsHelpers,
  });
  return { chartURL };
}
